import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import DataTable from "../../lib/DataTable";
import { Notice } from "../../lib/ui";

/* Activity logs – port of logs.php (API: /api/admin/logs, newest 5,000) */

export default function Logs() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/admin/logs").then(setRows).catch((e) => setError(e.message)); }, [api]);
  const columns = [
    { key: "id", label: "ID", num: true }, { key: "created_at", label: "Time" }, { key: "username", label: "User", render: (r) => <b style={{ color: "var(--ink)" }}>{r.username}</b> },
    { key: "action_type", label: "Action" }, { key: "entity_type", label: "Entity" }, { key: "entity_id", label: "Entity ID" },
    { key: "description", label: "Description", render: (r) => <span style={{ color: "var(--ink-2)" }}>{r.description}</span> }, { key: "ip_address", label: "IP" },
    { key: "user_agent", label: "Device", render: (r) => <span title={r.user_agent} style={{ display: "inline-block", maxWidth: "14rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "var(--muted)" }}>{r.user_agent}</span> },
  ];
  return (
    <main className="pg" style={{ maxWidth: "100rem" }}>
      <PageHeader slug="logs" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">{rows ? <DataTable columns={columns} rows={rows} rowKey={(r) => r.id} searchPlaceholder="Search logs" initialSort={{ key: "id", dir: -1 }} empty="No activity logs found." />
        : !error && <div className="empty"><i className="fas fa-spinner fa-spin" />Loading…</div>}</section>
    </main>
  );
}
